import type { GuardPredicate } from './types'

/**
 * Guard: Blocks selection if user has already started the form
 * Once user begins answering questions, questionnaire cannot change
 *
 * Note: Only blocks if monarchQuestionnaireName is already set AND user has progressed.
 * This allows initial selection even when currentStepIndex > 0 (e.g., when interstitial is pre-filled)
 */
export const userAlreadyStartedGuard: GuardPredicate = (context) => ({
  shouldBlock: context.monarchQuestionnaireName !== null && context.currentStepIndex > 0,
  reason: 'User already started form',
})
